import { render, staticRenderFns } from "./colorPicker.vue?vue&type=template&id=45697733&"
import script from "./colorPicker.vue?vue&type=script&lang=ts&"
export * from "./colorPicker.vue?vue&type=script&lang=ts&"
import style0 from "./colorPicker.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports